import React, { useState, useEffect } from 'react';
import {
  Container,
  SimpleGrid,
  Box,
  Icon,
  Divider,
  Body,
} from '@hover/blueprint';
import { HOME_PAGE_TABS } from '../../../constants';
import { Progress } from '../../ui';
import { IHomePageTabs } from '../../../interfaces/IHomePageTabs';

interface Props {
  currentTab: string;
  resetTimer: (title: string) => void;
}

const BetterSectionDesktopTabs: React.FC<Props> = ({
  currentTab,
  resetTimer,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const index = HOME_PAGE_TABS.findIndex(tab => tab.title === currentTab);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  const onReset = (title: string, id: number) => {
    const element = document.getElementById(
      `home-page-tabs-${id}`,
    ) as HTMLVideoElement;
    const prevElement = document.getElementById(
      `home-page-tabs-${index ?? 0}`,
    ) as HTMLVideoElement;
    if (prevElement) {
      prevElement.pause();
      prevElement.currentTime = 0;
    }
    if (element) {
      element.currentTime = 0;
      void element.play();
    }
    resetTimer(title);
  };

  useEffect(() => {
    if (!isLoading) {
      const element = document.getElementById(
        `home-page-tabs-${index ?? 0}`,
      ) as HTMLVideoElement;
      if (element) {
        void element.play();
      }
    }
  }, [isLoading, currentTab]);

  return (
    <Container centerContent maxW="1200px" d={{ base: 'none', tablet: 'flex' }}>
      {HOME_PAGE_TABS.map((listItem: IHomePageTabs) => (
        <Box
          key={listItem.title}
          d={listItem.title === currentTab ? 'flex' : 'none'}
          alignItems="center"
          position="relative"
          justifyContent="center"
          w="100%"
        >
          <Box
            zIndex={11}
            maxH="355px"
            justifyContent="center"
            position="relative"
          >
            {listItem.renderVideo({
              id: `home-page-tabs-${listItem.id}`,
              className: 'hero-page-tab',
            })}
            <Box
              position="absolute"
              bottom="-5px"
              left={0}
              right={0}
              h="10px"
              bg="neutral.0"
            />
          </Box>
        </Box>
      ))}
      <SimpleGrid columns={4} spacing={0} w="100%">
        {HOME_PAGE_TABS.map(listItem => {
          const isCurrent = listItem.title === currentTab;
          return (
            <Box
              cursor="pointer"
              flexDir="column"
              alignItems="flex-start"
              mt={400}
              onClick={() => onReset(listItem.title, listItem.id)}
            >
              {listItem.icon ? (
                <Icon
                  mb={500}
                  icon={listItem.icon}
                  size="large"
                  color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
                />
              ) : (
                <Icon
                  mb={500}
                  icon={!isCurrent ? listItem.svgIcon : listItem.svgIconActive}
                  size="large"
                  color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
                />
              )}
              {isCurrent && !isLoading ? (
                <Progress />
              ) : (
                <Divider color="neutral.300" my={0} />
              )}
              <Body
                letterSpacing="2px"
                mt={800}
                mb={400}
                size={500}
                isBold
                lineHeight="20px"
                textTransform="uppercase"
                color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
              >
                {listItem.title.toUpperCase()}
              </Body>
              <Body
                maxW="90%"
                size={600}
                color={isCurrent ? 'neutral.700' : 'neutral.500'}
              >
                {listItem.body}
              </Body>
            </Box>
          );
        })}
      </SimpleGrid>
    </Container>
  );
};

export default BetterSectionDesktopTabs;
